

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function ($rootScope, $state) {
    // Decorate the current state with the transition params
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        $state.toState = toState;
        $state.toParams = toParams;
        $state.fromState = fromState;
        $state.fromParams = fromParams;
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/lib/stateChangeListener.js
// module id = ./js/lib/stateChangeListener.js
// module chunks = 1